import React from "react";
import { Link } from "gatsby";

const Sticky = ({ title, subtitle, shopLink }) => {
  return (
    <div className="sticky-inner">
      <div className="sticky-content flex flex-wrap justify-between items-center p-4 lg:p-0">
        <div>
          <h1 className="text-white text-35 md:text-60">{title}™</h1>
        </div>
        {title !== "Joint Pain Sucks" && (
          <Link to={`/shop/${shopLink}`}>
            <div className="bg-green text-white px-4 h-7 flex items-center rounded-tl-lg rounded-br-lg cursor-pointer">
              Shop
            </div>
          </Link>
        )}
        <div className="w-full">
          <h5 className="text-gray-lighter text-md max-w-sm">{subtitle}</h5>
        </div>
      </div>
    </div>
  );
};

export default Sticky;
